import React, { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import { Translation as T } from "@awe-web/shared/lib";
import { useInitialize } from "../../../util/react.js";
import { ScreenSection, ScreenHeading, ScreenLoading } from "../../../components/screen.js";
import { Row, Col } from "../../../components/grid.js";
import { TypeArea } from "../../../components/layout.js";
import { InlineLoadingIndicator } from "../../../components/loading_indicator.jsx";
import { initialize, submit } from "./actions.js";
import MyBmwRentProfileForm from "./my_bmw_rent_profile_form";

const MY_PROFILE = "FSD0000305";
const PROFILE_LOADING = "FSD0000359";

export default function MyBmwRentProfile() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [captchaToken, setCaptchaToken] = useState();

  const onCaptchaChange = useCallback((captchaToken) => {
    setCaptchaToken(captchaToken);
  }, []);

  const onSubmit = useCallback(async (formValues, formikProps) => {
    formValues = { ...formValues, captchaToken };
    const nextPath = await dispatch(submit(formValues, formikProps));
    if (nextPath && nextPath.length > 0) {
      navigate(nextPath);
    }
  }, [dispatch, navigate, captchaToken]);

  const init = useCallback(async () => {
    await dispatch(initialize());
  }, [dispatch]);

  const isReady = useInitialize(init);
  if (!isReady) {
    return <ScreenLoading />;
  }

  return (
    <div className="my-bmw-rent-profile">
      <ScreenSection main dark>
        <TypeArea>
          <Row>
            <Col desktop={{ cols: 8, offset: 2 }}>
              <ScreenHeading>
                <T code={MY_PROFILE} />
              </ScreenHeading>
            </Col>
          </Row>

          <InlineLoadingIndicator
            typePrefix="USER/FORM_CONFIGURATION"
            message={<T code={PROFILE_LOADING} />}
          >
            <MyBmwRentProfileForm onSubmit={onSubmit}  onCaptchaChange={onCaptchaChange}/>
          </InlineLoadingIndicator>
        </TypeArea>
      </ScreenSection>
    </div>
  );
}
